export const part2Data = [
  {
    id: "p2_1",
    audio: "/audio/part2/p2_1.mp3",
    english: "Have you checked your email yet?",
    chunks: [
      { korean: "확인해 보셨나요", english: "Have you checked" },
      { korean: "이메일을", english: "your email" },
      { korean: "아직", english: "yet" },
    ],
  },
  {
    id: "p2_2",
    audio: "/audio/part2/p2_2.mp3",
    english: "Interns get paid less, don't they?",
    chunks: [
      { korean: "인턴들은", english: "Interns" },
      { korean: "받죠 적게", english: "get paid less" },
      { korean: "그렇지 않나요?", english: "don't they" },
    ],
  },
  {
    id: "p2_3",

    english: "Where's the new fax machine?",
    chunks: [
      { korean: "어디에 있나요", english: "Where's" },
      { korean: "새 팩스 기계가?", english: "the new fax machine" },
    ],
  },
  {
    id: "p2_4",

    english: "Which of the gym lockers is yours?",
    chunks: [
      { korean: "어느 것이", english: "Which" },
      { korean: "체육관 사물함 중에서", english: "of the gym lockers" },
      { korean: "당신의 것인가요?", english: "is yours" },
    ],
  },
  {
    id: "p2_5",

    english: "Who can we speak to regarding the product defects?",
    chunks: [
      { korean: "누구와 이야기할 수 있나요", english: "Who can we speak to" },
      {
        korean: "제품 결함에 관해서",
        english: "regarding the product defects",
      },
    ],
  },
  {
    id: "p2_6",

    english: "Why was the job interview so short?",
    chunks: [
      { korean: "왜", english: "Why was" },
      { korean: "취업 면접이", english: "the job interview" },
      { korean: "그렇게 짧았어요?", english: "so short" },
    ],
  },
  {
    id: "p2_7",

    english: "Do you know who is replacing Adam while he is away?",
    chunks: [
      { korean: "알고 있나요", english: "Do you know" },
      { korean: "누가 대체하는지", english: "who is replacing" },
      { korean: "아담을", english: "Adam" },
      { korean: "그가 자리를 비운 동안?", english: "while he is away" },
    ],
  },
  {
    id: "p2_8",

    english: "Does Mr. Lee have a retirement plan?",
    chunks: [
      { korean: "이 씨가 가지고 있나요", english: "Does Mr. Lee have" },
      { korean: "퇴직 계획을?", english: "a retirement plan" },
    ],
  },
  {
    id: "p2_9",

    english: "Can you provide a portfolio showcasing your work?",
    chunks: [
      { korean: "제공해 주실 수 있나요", english: "Can you provide" },
      { korean: "포트폴리오를", english: "a portfolio" },
      { korean: "보여주는 당신의 작업을?", english: "showcasing your work" },
    ],
  },
  {
    id: "p2_10",

    english: "Will you register for the event?",
    chunks: [
      { korean: "등록하실 건가요", english: "Will you register" },
      { korean: "행사에?", english: "for the event" },
    ],
  },

  {
    id: "p2_11",

    english: "Do you commute to work every day?",
    chunks: [
      { korean: "통근하나요", english: "Do you commute" },
      { korean: "직장에", english: "to work" },
      { korean: "매일?", english: "every day" },
    ],
  },
  {
    id: "p2_12",

    english: "Should we lock the warehouse?",
    chunks: [
      { korean: "우리가 잠가야 할까요", english: "Should we lock" },
      { korean: "창고를?", english: "the warehouse" },
    ],
  },
  {
    id: "p2_13",

    english: "Have you visited the new factory?",
    chunks: [
      { korean: "방문했나요", english: "Have you visited" },
      { korean: "새 공장을?", english: "the new factory" },
    ],
  },
  {
    id: "p2_14",

    english: "Does Ms. Jones know that I will be away on Thursday?",
    chunks: [
      { korean: "존스 씨가 알고 있나요", english: "Does Ms. Jones know" },
      {
        korean: "그.. 제가 자리를 비울 거라는 것을",
        english: "that I will be away",
      },
      { korean: "목요일에?", english: "on Thursday" },
    ],
  },
  {
    id: "p2_15",

    english: "Will you be attending the board meeting this Friday?",
    chunks: [
      { korean: "참석하실 건가요", english: "Will you be attending" },
      { korean: "이사회 회의에", english: "the board meeting" },
      { korean: "이번 금요일에?", english: "this Friday" },
    ],
  },
  {
    id: "p2_16",

    english: "Did anyone go to yesterday's workshop?",
    chunks: [
      { korean: "누구 갔나요", english: "Did anyone go" },
      { korean: "어제 워크숍에?", english: "to yesterday's workshop" },
    ],
  },
  {
    id: "p2_17",

    english: "Can we finish the project before the deadline?",
    chunks: [
      { korean: "우리가 끝낼 수 있을까요", english: "Can we finish" },
      { korean: "프로젝트를", english: "the project" },
      { korean: "마감일 전에?", english: "before the deadline" },
    ],
  },
  {
    id: "p2_18",

    english: "Do you think I should rent this apartment?",
    chunks: [
      { korean: "생각하시나요", english: "Do you think" },
      { korean: "제가 임대해야 한다고", english: "I should rent" },
      { korean: "이 아파트를?", english: "this apartment" },
    ],
  },
  {
    id: "p2_19",

    english: "Can we leave for the airport now?",
    chunks: [
      { korean: "우리가 출발할 수 있을까요", english: "Can we leave" },
      { korean: "공항으로", english: "for the airport" },
      { korean: "지금?", english: "now" },
    ],
  },
  {
    id: "p2_20",

    english: "Have all of these clearance items been sold?",
    chunks: [
      {
        korean: "이 모든 할인 상품들이",
        english: "Have all of these clearance items",
      },
      { korean: "판매되었나요?", english: "been sold" },
    ],
  },
  {
    id: "p2_21",

    english: "Have you been to the art gallery yet?",
    chunks: [
      { korean: "당신은 가봤나요", english: "Have you been" },
      { korean: "미술관에", english: "to the art gallery" },
      { korean: "아직?", english: "yet" },
    ],
  },
  {
    id: "p2_22",

    english: "Did you have to make any adjustments to the office?",
    chunks: [
      { korean: "당신은 해야 했나요", english: "Did you have to make" },
      { korean: "어떤 조정을", english: "any adjustments" },
      { korean: "사무실에?", english: "to the office" },
    ],
  },
  {
    id: "p2_23",

    english: "Does the copy machine on the third floor work?",
    chunks: [
      { korean: "작동하나요", english: "Does work" },
      { korean: "복사기가", english: "the copy machine" },
      { korean: "3층에 있는?", english: "on the third floor" },
    ],
  },
  {
    id: "p2_24",

    english: "Martin, are you driving to the client meeting?",
    chunks: [
      { korean: "마틴, 당신이 운전하나요", english: "Martin, are you driving" },
      { korean: "고객 미팅으로?", english: "to the client meeting" },
    ],
  },
  {
    id: "p2_25",

    english: "Was that TV show interesting?",
    chunks: [
      { korean: "그 TV 프로그램이", english: "Was that TV show" },
      { korean: "재미있었나요?", english: "interesting" },
    ],
  },
  {
    id: "p2_26",

    english: "Is the construction of a new factory almost complete?",
    chunks: [
      { korean: "건설이", english: "Is the construction" },
      { korean: "새 공장", english: "of a new factory" },
      { korean: "거의 완료되었나요?", english: "almost complete" },
    ],
  },
  {
    id: "p2_27",

    english: "Is John going to the party this Friday night?",
    chunks: [
      { korean: "존은 갈 예정인가요", english: "Is John going" },
      { korean: "파티에", english: "to the party" },
      { korean: "이번 금요일 밤?", english: "this Friday night" },
    ],
  },
  {
    id: "p2_28",

    english: "Is tomorrow's workshop scheduled to last all day?",
    chunks: [
      { korean: "내일 워크숍이", english: "Is tomorrow's workshop" },
      { korean: "예정되어 있나요", english: "scheduled" },
      { korean: "지속될 하루종일?", english: "to last all day" },
    ],
  },
  {
    id: "p2_29",

    english: "Have you signed up for tomorrow's seminar?",
    chunks: [
      { korean: "당신은 등록했나요", english: "Have you signed up" },
      { korean: "내일 세미나에?", english: "for tomorrow's seminar" },
    ],
  },
  {
    id: "p2_30",

    english: "Was the shipping on your order expedited?",
    chunks: [
      { korean: "배송이", english: "Was the shipping" },
      { korean: "당신의 주문에", english: "on your order" },
      { korean: "빨라졌나요?", english: "expedited" },
    ],
  },
  {
    id: "p2_31",

    english: "Are you aware of the new dress code?",
    chunks: [
      { korean: "당신은 알고 있나요", english: "Are you aware" },
      { korean: "새로운 복장 규정에 대해?", english: "of the new dress code" },
    ],
  },
  {
    id: "p2_32",
    english: "Is she trying to find another assistant to replace Jessica?",
    chunks: [
      { korean: "그녀는 시도 하고 있나요", english: "Is she trying" },
      { korean: "찾으려고", english: "to find" },
      { korean: "다른 보조원을", english: "another assistant" },
      { korean: "대체하기 위해", english: "to replace" },
      { korean: "제시카를?", english: "Jessica" },
    ],
  },
  {
    id: "p2_33",
    english:
      "Were the invitations for the fundraiser mailed out this morning yet?",
    chunks: [
      { korean: "초대장이", english: "Were the invitations" },
      { korean: "모금 행사를 위한", english: "for the fundraiser" },
      { korean: "발송되었나요", english: "mailed out" },
      { korean: "오늘 아침에 벌써?", english: "this morning yet" },
    ],
  },
  {
    id: "p2_34",
    english: "How is everything going with the renovation project?",
    chunks: [
      { korean: "어떻게 진행되고 있나요", english: "How is everything going" },
      {
        korean: "리모델링 프로젝트는?",
        english: "with the renovation project",
      },
    ],
  },
  {
    id: "p2_35",
    english: "How often are factory inspections conducted?",
    chunks: [
      { korean: "얼마나 자주", english: "How often" },
      { korean: "공장 검사가", english: "are factory inspections" },
      { korean: "수행되나요?", english: "conducted" },
    ],
  },
  {
    id: "p2_36",
    english: "How many people are coming to the conference?",
    chunks: [
      { korean: "몇 명이", english: "How many people" },
      { korean: "오고 있나요", english: "are coming" },
      { korean: "컨퍼런스에?", english: "to the conference" },
    ],
  },
  {
    id: "p2_37",
    english: "How long have you known the head of HR?",
    chunks: [
      { korean: "얼마나 오래", english: "How long" },
      { korean: "알고 지냈나요", english: "have you known" },
      { korean: "인사부장을?", english: "the head of HR" },
    ],
  },
  {
    id: "p2_38",
    english: "How large was their investment?",
    chunks: [
      { korean: "얼마나 컸나요", english: "How large was" },
      { korean: "그들의 투자가?", english: "their investment" },
    ],
  },
  {
    id: "p2_39",
    english: "How many boxes are we going to disassemble today?",
    chunks: [
      { korean: "몇 개의 상자를", english: "How many boxes" },
      {
        korean: "우리가 분해할 예정인가요",
        english: "are we going to disassemble",
      },
      { korean: "오늘?", english: "today" },
    ],
  },
  {
    id: "p2_40",
    english: "How should we set up the tables for the wedding?",
    chunks: [
      { korean: "어떻게 해야 할까요", english: "How should we" },
      { korean: "배치하는 것을 테이블을", english: "set up the tables" },
      { korean: "결혼식을 위해?", english: "for the wedding" },
    ],
  },
  {
    id: "p2_41",
    english: "How come you didn't show up at the party yesterday?",
    chunks: [
      { korean: "어째서", english: "How come" },
      { korean: "나타나지 않았나요", english: "you didn't show up" },
      { korean: "파티에", english: "at the party" },
      { korean: "어제?", english: "yesterday" },
    ],
  },
  {
    id: "p2_42",
    english: "How will they be informed about the meeting?",
    chunks: [
      { korean: "어떻게", english: "How" },
      { korean: "그들이 통보받을 것인가요", english: "will they be informed" },
      { korean: "회의에 대해?", english: "about the meeting" },
    ],
  },
  {
    id: "p2_43",
    english: "How do you manage in your new position?",
    chunks: [
      { korean: "어떻게", english: "How do you" },
      { korean: "관리하고 있나요", english: "manage" },
      { korean: "당신의 새 직책에서?", english: "in your new position" },
    ],
  },
  {
    id: "p2_44",
    english: "How will you get to the conference center?",
    chunks: [
      { korean: "어떻게", english: "How" },
      { korean: "당신은 갈 것인가요", english: "will you get" },
      { korean: "컨퍼런스 센터까지?", english: "to the conference center" },
    ],
  },

  {
    id: "p2_45",
    english: "Would you like a bowl of salad or some toast?",
    chunks: [
      { korean: "원하시나요", english: "Would you like" },
      { korean: "한 그릇의 샐러드", english: "a bowl of salad" },
      { korean: "아니면", english: "or" },
      { korean: "조금의 토스트?", english: "some toast" },
    ],
  },
  {
    id: "p2_46",
    english:
      "Is Rachel done designing the website, or is she still working on it?",
    chunks: [
      { korean: "레이첼이 완료했나요", english: "Is Rachel done" },
      { korean: "웹사이트 디자인을", english: "designing the website" },
      { korean: "아니면", english: "or" },
      { korean: "아직 작업 중인가요?", english: "is she still working on it" },
    ],
  },
  {
    id: "p2_47",
    english:
      "Will you have time to go through the contract this morning or this afternoon?",
    chunks: [
      { korean: "시간이 있으실까요", english: "Will you have time" },
      { korean: "검토할 계약서를", english: "to go through the contract" },
      { korean: "오전에", english: "this morning" },
      { korean: "아니면", english: "or" },
      { korean: "오후에?", english: "this afternoon" },
    ],
  },
  {
    id: "p2_48",
    english: "Is the New York time zone ahead of us or behind our time zone?",
    chunks: [
      { korean: "뉴욕 시간대가", english: "Is the New York time zone" },
      { korean: "앞서 있나요 우리보다", english: "ahead of us" },
      { korean: "아니면", english: "or" },
      {
        korean: "뒤쳐져 있나요 우리 시간대보다?",
        english: "behind our time zone",
      },
    ],
  },
  {
    id: "p2_49",
    english: "Would you rather go to a movie or a play?",
    chunks: [
      { korean: "더 선호하시나요", english: "Would you rather" },
      { korean: "영화를 보러 가는 것을", english: "go to a movie" },
      { korean: "아니면", english: "or" },
      { korean: "연극을?", english: "a play" },
    ],
  },
  {
    id: "p2_50",
    english: "Have you chosen the new photographer or are you still deciding?",
    chunks: [
      { korean: "선택하셨나요", english: "Have you chosen" },
      { korean: "새 사진작가를", english: "the new photographer" },
      { korean: "아니면", english: "or" },
      { korean: "아직 결정 중인가요?", english: "are you still deciding" },
    ],
  },
  {
    id: "p2_51",
    english: "Didn't you return all the items?",
    chunks: [
      { korean: "반납하지 않았나요", english: "Didn't you return" },
      { korean: "모든 물품을?", english: "all the items" },
    ],
  },
  {
    id: "p2_52",
    english: "Don't you agree that Mr. Shannon's speech was inspiring?",
    chunks: [
      { korean: "동의하지 않으세요", english: "Don't you agree" },
      { korean: "그..샤논 씨의 연설이", english: "that Mr. Shannon's speech" },
      { korean: "영감을 주는 것이었다고?", english: "was inspiring" },
    ],
  },
  {
    id: "p2_53",
    english: "Aren't you supposed to meet with the client now?",
    chunks: [
      {
        korean: "만나야 하는 것 아닌가요",
        english: "Aren't you supposed to meet",
      },
      { korean: "고객과", english: "with the client" },
      { korean: "지금?", english: "now" },
    ],
  },
  {
    id: "p2_54",
    english: "Shouldn't we discuss the union's requests now?",
    chunks: [
      { korean: "논의해야 하지 않을까요", english: "Shouldn't we discuss" },
      { korean: "노동조합의 요청을", english: "the union's requests" },
      { korean: "지금?", english: "now" },
    ],
  },
  {
    id: "p2_55",
    english: "Wouldn't a larger venue be better for the upcoming trade fair?",
    chunks: [
      {
        korean: "더 큰 장소가 좋지 않을까요",
        english: "Wouldn't a larger venue be better",
      },
      {
        korean: "다가오는 무역 박람회를 위해?",
        english: "for the upcoming trade fair",
      },
    ],
  },
  {
    id: "p2_56",
    english:
      "Aren't you going to hire a catering company for next week's fundraising event?",
    chunks: [
      {
        korean: "고용하지 않을 건가요",
        english: "Aren't you going to hire",
      },
      {
        korean: "케이터링 회사를",
        english: "a catering company",
      },
      {
        korean: "다음 주 기금 모금 행사를 위해?",
        english: "for next week's fundraising event",
      },
    ],
  },
  {
    id: "p2_57",
    english: "Won't a meal be served during the flight?",
    chunks: [
      {
        korean: "식사가 제공되지 않을까요",
        english: "Won't a meal be served",
      },
      {
        korean: "비행 중에?",
        english: "during the flight",
      },
    ],
  },
  {
    id: "p2_58",
    english: "We can expedite your shipment for an extra $15.",
    chunks: [
      {
        korean: "우리가 신속하게 처리할 수 있습니다",
        english: "We can expedite",
      },
      {
        korean: "당신의 배송을",
        english: "your shipment",
      },
      {
        korean: "추가 15달러에",
        english: "for an extra $15",
      },
    ],
  },
  {
    id: "p2_59",
    english:
      "Mr. Lawrence is on the phone, asking questions about our products.",
    chunks: [
      {
        korean: "로렌스 씨가 전화 중이에요",
        english: "Mr. Lawrence is on the phone",
      },
      {
        korean: "질문하며",
        english: "asking questions",
      },
      {
        korean: "우리 제품에 대해",
        english: "about our products",
      },
    ],
  },
  {
    id: "p2_60",
    english: "My flight to Portland was canceled due to a severe snowstorm.",
    chunks: [
      {
        korean: "저의 비행",
        english: "My flight",
      },
      {
        korean: "포틀랜드행",
        english: "to Portland",
      },
      {
        korean: "취소됬어요",
        english: "was canceled",
      },
      {
        korean: "심한 눈폭풍 때문에",
        english: "due to a severe snowstorm",
      },
    ],
  },
  {
    id: "p2_61",
    english: "Let me know which day works best for you.",
    chunks: [
      {
        korean: "알려주세요",
        english: "Let me know",
      },
      {
        korean: "어느 날이",
        english: "which day",
      },
      {
        korean: "가장 좋은지",
        english: "works best",
      },
      {
        korean: "당신에게",
        english: "for you",
      },
    ],
  },
  {
    id: "p2_62",
    english: "I thought you were going to meet with Mr. Patterson today.",
    chunks: [
      {
        korean: "저는 생각했어요",
        english: "I thought",
      },
      {
        korean: "당신이 만날 거라고",
        english: "you were going to meet",
      },
      {
        korean: "패터슨 씨와",
        english: "with Mr. Patterson",
      },
      {
        korean: "오늘",
        english: "today",
      },
    ],
  },
  {
    id: "p2_63",
    english: "Don't forget your doctor's appointment.",
    chunks: [
      {
        korean: "잊지 마세요",
        english: "Don't forget",
      },
      {
        korean: "당신의 의사 약속을",
        english: "your doctor's appointment",
      },
    ],
  },
  {
    id: "p2_64",
    english: "Make sure the assignment is handed in by Monday.",
    chunks: [
      {
        korean: "확인하세요",
        english: "Make sure",
      },
      {
        korean: "과제가 제출되도록",
        english: "the assignment is handed in",
      },
      {
        korean: "월요일까지",
        english: "by Monday",
      },
    ],
  },
  {
    id: "p2_65",
    english: "I'm sorry to keep you on hold.",
    chunks: [
      {
        korean: "죄송합니다",
        english: "I'm sorry",
      },
      {
        korean: "기다리게 해서",
        english: "to keep you on hold",
      },
    ],
  },
  {
    id: "p2_66",
    english: "I'm supposed to meet with Mr. Thomas this morning.",
    chunks: [
      {
        korean: "저는 만나기로 되어 있습니다",
        english: "I'm supposed to meet",
      },
      {
        korean: "토마스 씨와",
        english: "with Mr. Thomas",
      },
      {
        korean: "오늘 아침에",
        english: "this morning",
      },
    ],
  },
  {
    id: "p2_67",
    english: "I wasn't told about the schedule changes.",
    chunks: [
      {
        korean: "저는 듣지 못했습니다",
        english: "I wasn't told",
      },
      {
        korean: "일정 변경에 대해",
        english: "about the schedule changes",
      },
    ],
  },
  {
    id: "p2_68",
    english:
      "I heard there was going to be a festival in the park this weekend.",
    chunks: [
      {
        korean: "들었습니다",
        english: "I heard",
      },
      {
        korean: "축제가 열릴 예정이라고",
        english: "there was going to be a festival",
      },
      {
        korean: "공원에서",
        english: "in the park",
      },
      {
        korean: "이번 주말에",
        english: "this weekend",
      },
    ],
  },
  {
    id: "p2_69",
    english: "He is not working with Jason on the research, is he?",
    chunks: [
      {
        korean: "그는 일하고 있지 않습니다",
        english: "He is not working",
      },
      {
        korean: "제이슨과 함께",
        english: "with Jason",
      },
      {
        korean: "연구에",
        english: "on the research",
      },
      {
        korean: "그렇죠?",
        english: "is he?",
      },
    ],
  },
  {
    id: "p2_70",
    english:
      "Ms. Wang is supposed to be the keynote speaker at the seminar on Thursday, isn't she?",
    chunks: [
      {
        korean: "왕 씨가 될 예정입니다",
        english: "Ms. Wang is supposed to be",
      },
      {
        korean: "기조 연설자",
        english: "the keynote speaker",
      },
      {
        korean: "세미나에서",
        english: "at the seminar",
      },
      {
        korean: "목요일에",
        english: "on Thursday",
      },
      {
        korean: "그렇지 않나요?",
        english: "isn't she?",
      },
    ],
  },
  {
    id: "p2_71",
    english: "You will be on maternity leave for three months, won't you?",
    chunks: [
      {
        korean: "당신은 있을 것입니다",
        english: "You will be",
      },
      {
        korean: "출산 휴가 중",
        english: "on maternity leave",
      },
      {
        korean: "3개월 동안",
        english: "for three months",
      },
      {
        korean: "그렇지 않나요?",
        english: "won't you?",
      },
    ],
  },
  {
    id: "p2_72",
    english:
      "Alex hardly seems to participate in class discussions, doesn't he?",
    chunks: [
      {
        korean: "알렉스는 거의 참여하지 않는 것 같습니다",
        english: "Alex hardly seems to participate",
      },
      {
        korean: "수업 토론에",
        english: "in class discussions",
      },
      {
        korean: "그렇지 않나요?",
        english: "doesn't he?",
      },
    ],
  },
  {
    id: "p2_73",
    english:
      "Working overseas for two years has been a good experience for you, hasn't it?",
    chunks: [
      {
        korean: "일하는 것 해외에서",
        english: "Working overseas",
      },
      {
        korean: "2년 동안",
        english: "for two years",
      },
      {
        korean: "좋은 경험이었습니다",
        english: "has been a good experience",
      },
      {
        korean: "당신에게",
        english: "for you",
      },
      {
        korean: "그렇지 않나요?",
        english: "hasn't it?",
      },
    ],
  },
  {
    id: "p2_74",
    english: "That was a very informative seminar, wasn't it?",
    chunks: [
      {
        korean: "그것은 매우 유익한 세미나였습니다",
        english: "That was a very informative seminar",
      },
      {
        korean: "그렇지 않나요?",
        english: "wasn't it?",
      },
    ],
  },
  {
    id: "p2_75",
    english: "What is the date of the company outing?",
    chunks: [
      {
        korean: "무엇인가요",
        english: "What is",
      },
      {
        korean: "날짜",
        english: "the date",
      },
      {
        korean: "회사 야유회의",
        english: "of the company outing",
      },
    ],
  },
  {
    id: "p2_76",
    english: "What time will you get off work today?",
    chunks: [
      {
        korean: "몇 시에",
        english: "What time",
      },
      {
        korean: "퇴근할 거예요",
        english: "will you get off work",
      },
      {
        korean: "오늘",
        english: "today",
      },
    ],
  },
  {
    id: "p2_77",
    english: "What does Mr. Butler think of the new acquisition?",
    chunks: [
      {
        korean: "버틀러 씨는 어떻게 생각하나요",
        english: "What does Mr. Butler think",
      },
      {
        korean: "새로운 인수에 대해",
        english: "of the new acquisition",
      },
    ],
  },
  {
    id: "p2_78",
    english: "What venue does the annual conference take place at?",
    chunks: [
      {
        korean: "어떤 장소에서",
        english: "What venue",
      },
      {
        korean: "연례 회의가 열리나요",
        english: "does the annual conference take place at",
      },
    ],
  },
  {
    id: "p2_79",
    english: "What was the issue with the photocopier?",
    chunks: [
      {
        korean: "무엇이 문제였나요",
        english: "What was the issue",
      },
      {
        korean: "복사기에",
        english: "with the photocopier",
      },
    ],
  },
  {
    id: "p2_80",
    english: "When will I get a raise?",
    chunks: [
      {
        korean: "언제",
        english: "When",
      },
      {
        korean: "제가 급여 인상을 받을 수 있나요",
        english: "will I get a raise",
      },
    ],
  },
  {
    id: "p2_81",
    english: "When can we meet to discuss our new project?",
    chunks: [
      {
        korean: "언제",
        english: "When",
      },
      {
        korean: "우리가 만날 수 있을까요",
        english: "can we meet",
      },
      {
        korean: "논의하기 위해",
        english: "to discuss",
      },
      {
        korean: "새프로젝트에 대해",
        english: "our new project",
      },
    ],
  },
  {
    id: "p2_82",
    english: "When do I have to file my income taxes?",
    chunks: [
      {
        korean: "언제",
        english: "When",
      },
      {
        korean: "제가 제출해야 하나요",
        english: "do I have to file",
      },
      {
        korean: "소득세 신고서를",
        english: "my income taxes",
      },
    ],
  },
  {
    id: "p2_83",
    english: "When was the last time you saw Jennifer?",
    chunks: [
      {
        korean: "언제였나요",
        english: "When was",
      },
      {
        korean: "마지막으로",
        english: "the last time",
      },
      {
        korean: "당신이 제니퍼를 본 것이",
        english: "you saw Jennifer",
      },
    ],
  },
  {
    id: "p2_84",
    english: "Where do you normally do the grocery shopping?",
    chunks: [
      {
        korean: "어디에서",
        english: "Where",
      },
      {
        korean: "보통 하시나요",
        english: "do you normally do",
      },
      {
        korean: "식료품 쇼핑을",
        english: "the grocery shopping",
      },
    ],
  },
  {
    id: "p2_85",
    english: "Which table would you like to sit at?",
    chunks: [
      {
        korean: "어느 테이블에",
        english: "Which table",
      },
      {
        korean: "앉고 싶으신가요",
        english: "would you like to sit at",
      },
    ],
  },
  {
    id: "p2_86",
    english: "Which of these jeans look better on me?",
    chunks: [
      {
        korean: "어떤 청바지가",
        english: "Which of these jeans",
      },
      {
        korean: "더 잘 어울리나요",
        english: "look better",
      },
      {
        korean: "저에게",
        english: "on me",
      },
    ],
  },
  {
    id: "p2_87",
    english: "Which of the workshop sessions will you attend?",
    chunks: [
      {
        korean: "어떤 워크숍 세션에",
        english: "Which of the workshop sessions",
      },
      {
        korean: "참석하실 예정인가요",
        english: "will you attend",
      },
    ],
  },
  {
    id: "p2_88",
    english: "Which manager reviewed this report?",
    chunks: [
      {
        korean: "어떤 매니저가",
        english: "Which manager",
      },
      {
        korean: "이 보고서를 검토했나요",
        english: "reviewed this report",
      },
    ],
  },
  {
    id: "p2_89",
    english: "Who is eligible for health insurance coverage?",
    chunks: [
      {
        korean: "누가",
        english: "Who",
      },
      {
        korean: "자격이 있나요",
        english: "is eligible",
      },
      {
        korean: "건강보험혜택",
        english: "for health insurance coverage",
      },
    ],
  },
  {
    id: "p2_90",
    english: "Who was promoted to project manager?",
    chunks: [
      {
        korean: "누가",
        english: "Who",
      },
      {
        korean: "승진했나요",
        english: "was promoted",
      },
      {
        korean: "프로젝트 매니저로",
        english: "to project manager",
      },
    ],
  },
  {
    id: "p2_91",
    english: "Who will be taking care of the training session tomorrow?",
    chunks: [
      {
        korean: "누가",
        english: "Who",
      },
      {
        korean: "담당할 것인가요",
        english: "will be taking care of",
      },
      {
        korean: "교육 세션을",
        english: "the training session",
      },
      {
        korean: "내일",
        english: "tomorrow",
      },
    ],
  },
  {
    id: "p2_92",
    english: "Whom can we speak to about our mortgage loans?",
    chunks: [
      {
        korean: "누구와",
        english: "Whom",
      },
      {
        korean: "이야기할 수 있나요",
        english: "can we speak to",
      },
      {
        korean: "우리의 주택담보대출에 관해",
        english: "about our mortgage loans",
      },
    ],
  },
  {
    id: "p2_93",
    english: "Who will be our new marketing director?",
    chunks: [
      {
        korean: "누가",
        english: "Who",
      },
      {
        korean: "될 것인가요",
        english: "will be",
      },
      {
        korean: "우리의 새 마케팅 디렉터로",
        english: "our new marketing director",
      },
    ],
  },
  {
    id: "p2_94",
    english: "Why did Mr. Anderson leave a message to the receptionist?",
    chunks: [
      {
        korean: "왜",
        english: "Why",
      },
      {
        korean: "앤더슨 씨는",
        english: "did Mr. Anderson",
      },
      {
        korean: "메시지를 남겼나요",
        english: "leave a message",
      },
      {
        korean: "접수원에게",
        english: "to the receptionist",
      },
    ],
  },
  {
    id: "p2_95",
    english: "Why was the sales meeting postponed?",
    chunks: [
      {
        korean: "왜",
        english: "Why",
      },
      {
        korean: "판매 회의가",
        english: "was the sales meeting",
      },
      {
        korean: "연기되었나요",
        english: "postponed",
      },
    ],
  },

  {
    id: "p2_96",
    english: "Why isn't our product selling well in Japan?",
    chunks: [
      {
        korean: "왜",
        english: "Why",
      },
      {
        korean: "우리 제품이 잘 팔리지 않나요",
        english: "isn't our product selling well",
      },
      {
        korean: "일본에서",
        english: "in Japan",
      },
    ],
  },
  {
    id: "p2_97",
    english: "Why haven't those sales prediction reports been completed yet?",
    chunks: [
      {
        korean: "왜",
        english: "Why",
      },
      {
        korean: "그 판매 예측 보고서들이",
        english: "haven't those sales prediction reports",
      },
      {
        korean: "아직 완료되지 않았나요",
        english: "been completed yet",
      },
    ],
  },
  {
    id: "p2_98",
    english: "Have you seen what was posted on the bulletin board?",
    chunks: [
      {
        korean: "보셨나요",
        english: "Have you seen",
      },
      {
        korean: "게시된 것을",
        english: "what was posted",
      },
      {
        korean: "게시판에",
        english: "on the bulletin board",
      },
    ],
  },
  {
    id: "p2_99",
    english: "Why don't you take a day off tomorrow?",
    chunks: [
      {
        korean: "왜",
        english: "Why",
      },
      {
        korean: "하루 휴가를 내지 않나요",
        english: "don't you take a day off",
      },
      {
        korean: "내일",
        english: "tomorrow",
      },
    ],
  },
  {
    id: "p2_100",
    english: "Did the email mention why the contract was terminated?",
    chunks: [
      {
        korean: "이메일에서 언급했나요",
        english: "Did the email mention",
      },
      {
        korean: "왜",
        english: "why",
      },
      {
        korean: "계약이 종료되었는지",
        english: "the contract was terminated",
      },
    ],
  },
];
